import { __decorate } from "tslib";
import { injectable } from 'inversify';
import ModelBase from './ModelBase';
import { RelationType } from './Misc';
import { ChildList, ChildObject } from './Decorators';
import ValueObject from './ValueObject';
import { BindableBase } from './BindableBase';
var nonActionMethods = ["addBusinessRules", "toString"];
var ModelCreatorBase = /** @class */ (function () {
    function ModelCreatorBase() {
        this.alwaysInitialiseMembers = false;
    }
    Object.defineProperty(ModelCreatorBase.prototype, "shouldInitialiseAllMembers", {
        /**
         * True if all properties and methods need to be present in the property / method lists.
         * Otherwise only decorated members will be present (Mobx = only decorated, Vue = all)
         */
        get: function () {
            return this.typeInfo.inheritsBindableBase || this.alwaysInitialiseMembers;
        },
        enumerable: false,
        configurable: true
    });
    ModelCreatorBase.prototype.isBindableBase = function (type) {
        return type === BindableBase;
    };
    ModelCreatorBase.prototype.isModelBase = function (type) {
        return type === ModelBase;
    };
    ModelCreatorBase.prototype.initialise = function (typeInfo, originalConstructor) {
        this.typeInfo = typeInfo;
        if (this.shouldInitialiseAllMembers) {
            this.addPrototypeProperties(originalConstructor);
        }
    };
    ModelCreatorBase.prototype.addPrototypeProperties = function (ctor) {
        var prototype = ctor.prototype;
        for (var _i = 0, _a = Object.getOwnPropertyNames(prototype); _i < _a.length; _i++) {
            var propertyName = _a[_i];
            if (propertyName !== "constructor") {
                // Read only properties are converted to computeds
                var descriptor = Object.getOwnPropertyDescriptor(prototype, propertyName);
                if (descriptor.value !== void 0) {
                    // Method
                    if (typeof descriptor.value === 'function') {
                        this.addMethodInfo(propertyName, descriptor.value);
                    }
                }
                else if (descriptor.get) {
                    if (this.typeInfo.inheritsBindableBase) {
                        this.typeInfo.addComputed(propertyName, descriptor);
                    }
                }
            }
        }
    };
    /**
     * Ensures that lists / child objects have the correct relationType.
     */
    ModelCreatorBase.prototype.ensureChildInfo = function (instance, propertyInfo) {
        // @ts-ignore
        var propertyValue = instance[propertyInfo.propertyName];
        if (propertyValue) {
            if (propertyValue.childObjectType) {
                // This is a list.
                if (propertyInfo.relationType != RelationType.ChildList) {
                    // add missing annotation
                    propertyInfo = ChildList(propertyValue.childObjectType)(instance, propertyInfo.propertyName);
                }
            }
            else if (propertyValue instanceof ModelBase) {
                // Child object
                var isValueObject = propertyValue instanceof ValueObject;
                var relationType = isValueObject ? RelationType.ValueObject : RelationType.ChildObject;
                if (propertyInfo.relationType != relationType) {
                    propertyInfo = ChildObject(propertyValue.constructor, isValueObject)(instance, propertyInfo.propertyName);
                }
            }
        }
    };
    ModelCreatorBase.prototype.addMethodInfo = function (methodName, method) {
        var methodInfo = this.typeInfo.addMethod(methodName);
        if (nonActionMethods.indexOf(methodInfo.name) >= 0) {
            methodInfo.isAction = false;
        }
    };
    ModelCreatorBase = __decorate([
        injectable()
    ], ModelCreatorBase);
    return ModelCreatorBase;
}());
export { ModelCreatorBase };
